// - - - - - - - - - -
// lockMenuItem.js — #174 / SUP-9005
//
// buildLockMenuItem({ locked, lockable, isTimeTraveling }) → { label, disabled, title }
//
// Single source of truth for the Lock / Unlock context-menu item's label,
// disabled state, and tooltip. Used by BOTH right-click surfaces that can
// toggle a day's lock:
//   1. the CELL-level menu (OptimizerGrid, right-click empty cell area), and
//   2. the JOB-TILE menu (JobTile, fed from optimizerScreen) — added for
//      SUP-9005 so right-clicking a scheduled job still surfaces Park AND
//      Lock/Unlock in one menu instead of the cell menu shadowing Park.
//
// Extracting this keeps the two surfaces from drifting (the documented
// project pattern — see CLAUDE.md "When to extract a tiny utility module":
// this drives a user-facing decision used in two production code paths and
// is unit-tested, so test/production parity is guaranteed). The caller
// supplies the onClick (the actual tsToggleCellLock call).
//
// Rules (#182 + #186): a day can only be LOCKED when it has jobs/repairs or a
// non-OFF designation AND isn't OFF (lockable === true). UNLOCK is always
// available so a stray lock can be cleared. Locking/unlocking is disabled
// during Time Travel (the mutation is blocked anyway — live-only invariant).

export const LOCK_DISABLED_TIME_TRAVEL_TITLE =
  "Locking is disabled during Time Travel";
export const LOCK_DISABLED_NOT_ELIGIBLE_TITLE =
  "Only a day with jobs/repairs or a designation (e.g. BUFFER), and not marked OFF, can be locked";

export function buildLockMenuItem({ locked, lockable, isTimeTraveling } = {}) {
  const label = locked ? "Unlock this day" : "Lock this day";

  // Time Travel blocks everything (the mutation is blocked downstream too).
  // Otherwise, only LOCKING needs eligibility — UNLOCK is always allowed.
  const blockedByTimeTravel = Boolean(isTimeTraveling);
  const blockedByEligibility = !locked && !lockable;
  const disabled = blockedByTimeTravel || blockedByEligibility;

  let title;
  if (blockedByTimeTravel) {
    title = LOCK_DISABLED_TIME_TRAVEL_TITLE;
  } else if (blockedByEligibility) {
    title = LOCK_DISABLED_NOT_ELIGIBLE_TITLE;
  } else {
    title = undefined;
  }

  return { label, disabled, title };
}
